import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

function OpalCard ({ children, className, style, size }) {
  const cn = `opal-card${size ? `-${size}` : ''}`
  return (
    <div className={clsx(className, cn)} style={style}>
      {children}
    </div>
  )
}

OpalCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
}

export default OpalCard
